<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item to="/config/script">Script</b-breadcrumb-item>
          <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CCard class="custom-form-card mb-3">
        <CCardBody>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                invalid-feedback="This input is required."
                label="Deskripsi"
                label-for="script-desc"
                :state="createEditScript.paramDesc.isValid"
              >
                <b-form-textarea
                  v-model="createEditScript.paramDesc.value"
                  :state="createEditScript.paramDesc.isValid"
                  placeholder="Deskripsi"
                  maxlength="100"
                  id="script-desc"
                  rows="3"
                  max-rows="3"
                ></b-form-textarea>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                invalid-feedback="This input is required."
                label="Script"
                label-for="script-script"
                :state="createEditScript.paramScript.isValid"
              >
                <b-form-textarea
                  v-model="createEditScript.paramScript.value"
                  :state="createEditScript.paramScript.isValid"
                  placeholder="Script"
                  maxlength="3000"
                  id="script-script"
                  rows="3"
                  max-rows="3"
                ></b-form-textarea>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-12 col-md-6">
              <b-form-group
                invalid-feedback="This input is required."
                label="Tipe Transaksi"
                label-for="script-transType"
                :state="createEditScript.transType.isValid"
              >
                <multiselect 
                  v-model="createEditScript.transType.value" 
                  :options="createEditScript.transType.options" 
                  :state="createEditScript.transType.isValid"
                  :class="{custom_multiselect_invalid: createEditScript.transType.isValid === false}"
                  id="script-transType"
                  placeholder="Select an option"
                  :showLabels="false"
                  openDirection="bottom"
                  label="text"
                  track-by="value"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                </multiselect>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol class="col-xs-12 ml-5">
              <b-input-group>
                <b-input-group-prepend>
                  <!-- <b-form-select v-model="filter.value" :options="filter.options" disabled></b-form-select> -->
                  <multiselect 
                    v-model="filter.value" 
                    :options="filter.options" 
                    class="mb-0 filter-option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    :disabled="true"
                    style="width: 130px;"
                  >
                  </multiselect>
                </b-input-group-prepend>
                <b-input-group-append>
                  <multiselect 
                    v-model="filter.office" 
                    :options="mapTableItemTemplate.officeData.options" 
                    class="mb-0"
                    placeholder="Filter Office"
                    :showLabels="false"
                    openDirection="bottom"
                    label="nameFull"
                    track-by="officeCode"
                    :internalSearch="false"
                    :preserveSearch="false"
                    @search-change="populateOffice"
                    style="width: 200px;"
                    @input="filterOffice"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                    <template slot="noResult">No elements found.</template>
                    <template slot="afterList" v-if="mapTableItemTemplate.officeData.currentPage < mapTableItemTemplate.officeData.totalPages">
                      <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="mapTableItemTemplate.officeData.isLoaded">
                        <span class="text-muted">Load More</span>
                      </div>
                      <div class="text-center" v-else>
                        <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                      </div>
                    </template>
                  </multiselect>
                </b-input-group-append>
                <!-- <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel Notaris" @click="filterOffice">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append> -->
              </b-input-group>
            </CCol>
          </CRow>
          <CRow class="mt-3 mb-2">
            <CCol class="col-12">
              <b-table
                striped hover show-empty
                responsive="xl"
                :items="filter.office == null ? createEditScript.mapTable.items : createEditScript.mapTable.filteredItems"
                :fields="createEditScript.mapTable.fields"
              >
                <template slot="empty">
                  <div class="text-center">
                    Silahkan pilih Office lain
                  </div> 
                </template>
                <template #cell(bussUnit)="row">
                  <b-form-group
                    :invalid-feedback="row.item.bussUnit.feedback"
                    :state="row.item.bussUnit.isValid"
                    class="mb-0"
                  >
                    <multiselect 
                      v-model="row.item.bussUnit.value" 
                      :options="mapTableItemTemplate.bussUnitAvailOptions" 
                      :state="row.item.bussUnit.isValid"
                      :class="{custom_multiselect_invalid: row.item.bussUnit.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      @input="onInputBussUnit(row.item.index)"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="noResult">No elements found.</template>
                    </multiselect>
                  </b-form-group>
                </template>
                <template #cell(platform)="row">
                  <b-form-group
                    :invalid-feedback="row.item.platform.feedback"
                    :state="row.item.platform.isValid"
                    class="mb-0"
                  >
                    <multiselect 
                      v-model="row.item.platform.value" 
                      :options="mapTableItemTemplate.platformAvailOptions" 
                      :state="row.item.platform.isValid"
                      :class="{custom_multiselect_invalid: row.item.platform.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      @input="onInputPlatform(row.item.index)"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="noResult">No elements found.</template>
                    </multiselect>
                  </b-form-group>
                </template>
                <template #cell(company)="row">
                  <b-form-group
                    :invalid-feedback="row.item.company.feedback"
                    :state="row.item.company.isValid"
                    class="mb-0"
                  >
                    <multiselect 
                      v-model="row.item.company.value" 
                      :options="mapTableItemTemplate.companyAvailOptions" 
                      :state="row.item.company.isValid"
                      :class="{custom_multiselect_invalid: row.item.company.isValid === false}"
                      placeholder="Select an option"
                      :showLabels="false"
                      openDirection="bottom"
                      label="text"
                      track-by="value"
                      @input="onInputCompany(row.item.index)"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                      <template slot="noResult">No elements found.</template>
                    </multiselect>
                  </b-form-group>
                </template>
                <template #cell(office)="row">
                  <b-form-group
                    :invalid-feedback="row.item.office.feedback"
                    :state="row.item.office.isValid"
                    class="mb-0"
                  >
                    <multiselect 
                      v-model="row.item.office.value" 
                      :options="mapTableItemTemplate.officeData.options" 
                      :state="row.item.office.isValid"
                      class="mb-0"
                      :class="{custom_multiselect_invalid: row.item.office.isValid === false}"
                      id="script-office"
                      placeholder="Select an option"
                      :showLabels="false"
                      :loading="!mapTableItemTemplate.officeData.isLoaded"
                      openDirection="bottom"
                      label="nameFull"
                      track-by="officeCode"
                      :internalSearch="false"
                      :preserveSearch="false"
                      @search-change="populateOffice"
                      :disabled="filter.office != null"
                    >
                      <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                      <template slot="noResult">No elements found.</template>
                      <template slot="afterList" v-if="mapTableItemTemplate.officeData.currentPage < mapTableItemTemplate.officeData.totalPages">
                        <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="mapTableItemTemplate.officeData.isLoaded">
                          <span class="text-muted">Load More</span>
                        </div>
                        <div class="text-center" v-else>
                          <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                        </div>
                      </template>
                    </multiselect>
                  </b-form-group>
                </template>
                <!-- <template #cell(pnbpFee)="row">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label-for="script-pnbpFee"
                    :state="row.item.pnbpFee.isValid"
                    class="mt-3"
                  >
                    <b-form-input
                      v-model="row.item.pnbpFee.value"
                      :state="row.item.pnbpFee.isValid"
                      placeholder="PNBP Fee"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      id="script-pnbpFee"
                    ></b-form-input>
                  </b-form-group>
                </template> -->
                <template #cell(assign)="row">
                  <b-form-checkbox 
                    switch 
                    v-model="row.item.assign.value"
                    @input="onInputAssign(row.item.index)"></b-form-checkbox>
                </template>
                <template #cell(action)="row">
                  <b-button variant="danger" size="sm" title="Remove Row" @click="removeItem(row.item.index)" v-if="isShowRemoveButton(row.item.id)"><CIcon name="cil-minus"/></b-button>
                </template>
                <template #head(action)>
                  <b-button variant="primary" size="sm" title="Add New Row" @click="addItem"><CIcon name="cil-plus"/></b-button>
                </template>
              </b-table>
            </CCol>
          </CRow>
          <!-- <CRow class="my-2">
            <CCol>
              <b-alert show variant="warning">Apabila modifikasi script terdapat Business Unit, Office, Company dan Platform yang sama dengan data lama, data lama akan tergantikan oleh data terbaru</b-alert>
            </CCol>
          </CRow> -->
          <CRow>
            <CCol class="col-12 pt-3">
              <CButton color="primary" class="float-right" type="submit" style="width:7rem" :disabled="isSubmitting" @click="editScript">
                <b-spinner small v-if="isSubmitting" />
                {{ isSubmitting ? 'Sedang diproses...' : 'Save' }}
              </CButton>
              <b-btn variant="secondary" class="mr-2 float-right" @click="$router.push({name: 'Config Script List'})">Back</b-btn>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CForm>
  </CContainer>
</template>


<script>
export default {
  name: 'ConfigScriptEdit',
  data() {
    return {

      counter: 0,

      filter: {
        value: { value:"office", text: "Office" },
        options: [
          { value:"office", text: "Office" },
        ],
        office: null,
      },

      deletedParamScriptMapId: [],

      isSubmitting: false,
      isLoading: false,

      mapTableItemTemplate: {
        bussUnit: {
          value: null,
          isValid: null,
          feedback: 'This input is required.',
          isRequired: true,
          payloadKey: "bussUnit"
        },
        bussUnitAvailOptions: [],
        company: {
          value: null,
          isValid: null,
          feedback: 'This input is required.',
          isRequired: true,
          payloadKey: "coyId"
        },
        companyAvailOptions: [],
        office: {
          value: null,
          isValid: null,
          feedback: 'This input is required.',
          isRequired: true,
          payloadKey: "officeCode"
        },
        officeData: {
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },
        platform: {
          value: null,
          isValid: null,
          feedback: 'This input is required.',
          isRequired: true,
          payloadKey: "platform"
        },
        platformAvailOptions: [],
        // pnbpFee: {
        //   value: null,
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "royaReqAmount"
        // },
        assign: {
          value: true,
          isValid: null,
          isRequired: true,
          payloadKey: "assign"
        },
      },
      createEditScript: {
        paramDesc: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "paramDesc"
        },
        paramScript: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "paramScript"
        },
        transType: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [
            { value: "F", text: "Fiducia" },
            { value: "R", text: "Roya" }
          ],
          payloadKey: "transType"
        },
        mapTable: {
          fields: [
            { key: "bussUnit", label: "Business Unit" },
            { key: "office", label: "Office" },
            { key: "company", label: "Company" },
            { key: "platform", label: "Platform" },
            // { key: "pnbpFee", label: "PNBP Fee" },
            { key: "Assign", label: "Active" },
            { key: "action", label: "Aksi" }
          ],
          items: [],
          filteredItems: [],
          sort: {
            by: null,
            desc: false
          },
          currentPage: 1,
          perPage: 9999,
          totalRows: 0,
          totalPages: 0
        }
      }
    }
  },
  methods: {

    onInputBussUnit(idx) {
      if (this.filter.office != null) {
        let value = this.createEditScript.mapTable.filteredItems.filter(item => item.index == idx)[0].bussUnit.value
        this.createEditScript.mapTable.items.filter(item => item.index == idx)[0].bussUnit.value = value
      }
    },

    onInputPlatform(idx) {
      if (this.filter.office != null) {
        let value = this.createEditScript.mapTable.filteredItems.filter(item => item.index == idx)[0].platform.value
        this.createEditScript.mapTable.items.filter(item => item.index == idx)[0].platform.value = value
      }
    },

    onInputCompany(idx) {
      if (this.filter.office != null) {
        let value = this.createEditScript.mapTable.filteredItems.filter(item => item.index == idx)[0].company.value
        this.createEditScript.mapTable.items.filter(item => item.index == idx)[0].company.value = value
      }
    },

    onInputAssign(idx) {
      if (this.filter.office != null) {
        let value = this.createEditScript.mapTable.filteredItems.filter(item => item.index == idx)[0].assign.value
        this.createEditScript.mapTable.items.filter(item => item.index == idx)[0].assign.value = value
      }
    },

    filterOffice() {

      if (this.filter.office == null) {
        // console.log('office is null')
        this.createEditScript.mapTable.filteredItems = []
      } else{
        // console.log('office is not null')
        this.createEditScript.mapTable.filteredItems = this.createEditScript.mapTable.items.filter(item => item.office.value.officeCode == this.filter.office.officeCode)
      }
    },

    getScript(scriptId) {
      this.isLoading = true
      let getUrl = "/paramScript/getDetail/"

      let params = {
        paramId: scriptId
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.createEditScript.paramDesc.value = response.data.data.paramDesc
          this.createEditScript.paramScript.value = response.data.data.paramScript
          this.createEditScript.transType.value = this.createEditScript.transType.options.filter(obj => obj.value == response.data.data.transType)[0]
          let index = 0
          for (const item of response.data.data.paramScriptMap) {
            this.addInitialItem()

            this.createEditScript.mapTable.items[index].id = item.id
            this.createEditScript.mapTable.items[index].bussUnit.value = (item.bussUnit !== null) ? { value: item.bussUnit, text: item.bussUnitDesc } : null
            this.createEditScript.mapTable.items[index].office.value = (item.officeCode !== null) ? { nameFull: item.officeName, officeCode: item.officeCode } : null
            this.createEditScript.mapTable.items[index].company.value = (item.coyId !== null) ? { value: item.coyId, text: item.coyName } : null
            this.createEditScript.mapTable.items[index].platform.value = (item.platform !== null) ? { value: item.platform, text: item.platformName } : null
            // this.createEditScript.mapTable.items[index].pnbpFee.value = item.royaReqAmount
            this.createEditScript.mapTable.items[index].assign.value = item.assign

            index++
          }
        }
        else{
          this.$helper.toastError(this, "Load Detail Script Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Detail Script Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Detail Script Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    editScript(event) {
      event.preventDefault()

      this.filter.office = null

      let isFormValid = true
      let requiredValidation = true
      let obj = {
        paramId: this.$route.params.scriptId,
        deletedParamScriptMapId: this.deletedParamScriptMapId,
        paramScriptMap: []
      }

      // Validate Description
      if(this.$helper.isEmpty(this.createEditScript.paramDesc.value) && this.createEditScript.paramDesc.isRequired){
        this.createEditScript.paramDesc.isValid = false
        isFormValid = false
      } else{
        this.createEditScript.paramDesc.isValid = null
        obj[this.createEditScript.paramDesc.payloadKey] = this.createEditScript.paramDesc.value
      }

      // Validate Script
      if(this.$helper.isEmpty(this.createEditScript.paramScript.value) && this.createEditScript.paramScript.isRequired){
        this.createEditScript.paramScript.isValid = false
        isFormValid = false
      } else{
        this.createEditScript.paramScript.isValid = null
        obj[this.createEditScript.paramScript.payloadKey] = this.createEditScript.paramScript.value
      }

      // Validate Tipe Transaksi
      if(this.$helper.isEmpty(this.createEditScript.transType.value) && this.createEditScript.transType.isRequired){
        this.createEditScript.transType.isValid = false
        isFormValid = false
      } else{
        this.createEditScript.transType.isValid = null
        obj[this.createEditScript.transType.payloadKey] = this.createEditScript.transType.value.value
      }

      // Validate Map Table Items
      for (const item of this.createEditScript.mapTable.items) {
        let mapItemObj = {}
        for(const [key, data] of Object.entries(item)){
          if (key == "index") {
            continue
          } else if (key == "id") {
            mapItemObj.id = data
          } else{
            if(this.$helper.isEmpty(data.value) && data.isRequired){
              data.isValid = false
              isFormValid = false
              requiredValidation = false
            } else{
              data.isValid = null
              if (key == 'bussUnit' || key == 'company' || key == 'platform') {
                if (data.value != null) {
                  mapItemObj[data.payloadKey] = data.value.value
                } else{
                  mapItemObj[data.payloadKey] = data.value
                }
              } else if (key == 'office') {
                mapItemObj[data.payloadKey] = data.value.officeCode

              } else{ // PNBP Fee & Active (Assign)
                mapItemObj[data.payloadKey] = data.value
              }
            }
          }
        }

        if (requiredValidation) {
          
          if (obj.paramScriptMap.filter(param => param.bussUnit == mapItemObj['bussUnit'] && param.platform == mapItemObj['platform'] && param.coyId == mapItemObj['coyId'] && param.officeCode == mapItemObj['officeCode']).length > 0) {
            let errorMsg = 'Duplicate data.'
  
            item.bussUnit.feedback = errorMsg
            item.office.feedback = errorMsg
            item.company.feedback = errorMsg
            item.platform.feedback = errorMsg
  
            item.bussUnit.isValid = false
            item.office.isValid = false
            item.company.isValid = false
            item.platform.isValid = false
            isFormValid = false
          } else{
            item.bussUnit.isValid = null
            item.office.isValid = null
            item.company.isValid = null
            item.platform.isValid = null
          }
        }
        obj.paramScriptMap.push(mapItemObj)
      }

      if (isFormValid) {
        let postUrl = '/paramScript/edit/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$store.commit('set', ['toast', true])
              this.$store.commit('set', ['toastMsg', "Edit Script Berhasil! " + (response.data.reason ? response.data.reason : "")])
              this.$router.push({ name: 'Config Script List' });
            }
            else{
              this.$helper.toastError(this, "Edit Script Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Edit Script Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Edit Script Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    removeItem(idx) {
      let obj = this.createEditScript.mapTable.items.filter(item => item.index == idx)[0]
      if (obj.id !== -1) this.deletedParamScriptMapId.push(obj.id)

      if (this.filter.office != null) {
        this.createEditScript.mapTable.filteredItems = this.createEditScript.mapTable.filteredItems.filter(item => item.index != idx)
      }
      this.createEditScript.mapTable.items = this.createEditScript.mapTable.items.filter(item => item.index != idx)
    },

    onChangeBussUnit() {
      // enable all options
      for(let i = 0; i < this.mapTableItemTemplate.bussUnitAvailOptions.length; i++){
        this.mapTableItemTemplate.bussUnitAvailOptions[i].$isDisabled = false
      }
      // disable all already-selected options
      for(let i = 0; i < this.mapTableItemTemplate.bussUnitAvailOptions.length; i++){
        for(let j = 0; j < this.createEditScript.mapTable.items.length; j++){
          // if business unit in row is not empty
          if(!this.$helper.isEmpty(this.createEditScript.mapTable.items[j].bussUnit.value)){
            // if current option is already selected in a row
            if(this.mapTableItemTemplate.bussUnitAvailOptions[i].value == this.createEditScript.mapTable.items[j].bussUnit.value.value){
              // disable already selected option
              this.mapTableItemTemplate.bussUnitAvailOptions[i].$isDisabled = true
            }
          }
        }
      }
    },

    isShowRemoveButton(rowId) {
      // if last table item, do not remove
      if(this.createEditScript.mapTable.items.length <= 1) return false

      return true
    },

    addInitialItem() {
      this.createEditScript.mapTable.items.push({
        index: this.counter++,
        bussUnit: this.$lodash.cloneDeep(this.mapTableItemTemplate.bussUnit),
        office: this.$lodash.cloneDeep(this.mapTableItemTemplate.office),
        company: this.$lodash.cloneDeep(this.mapTableItemTemplate.company),
        platform: this.$lodash.cloneDeep(this.mapTableItemTemplate.platform),
        // pnbpFee: this.$lodash.cloneDeep(this.mapTableItemTemplate.pnbpFee),
        assign: this.$lodash.cloneDeep(this.mapTableItemTemplate.assign)
      })
    },

    addItem() {
      this.createEditScript.mapTable.items.unshift({
        index: this.counter,
        bussUnit: this.$lodash.cloneDeep(this.mapTableItemTemplate.bussUnit),
        office: this.$lodash.cloneDeep(this.mapTableItemTemplate.office),
        company: this.$lodash.cloneDeep(this.mapTableItemTemplate.company),
        platform: this.$lodash.cloneDeep(this.mapTableItemTemplate.platform),
        // pnbpFee: this.$lodash.cloneDeep(this.mapTableItemTemplate.pnbpFee),
        assign: this.$lodash.cloneDeep(this.mapTableItemTemplate.assign)
      })
      
      if (this.filter.office != null) {
        this.createEditScript.mapTable.filteredItems.unshift({
          index: this.counter,
          bussUnit: this.$lodash.cloneDeep(this.mapTableItemTemplate.bussUnit),
          office: this.$lodash.cloneDeep(this.mapTableItemTemplate.office),
          company: this.$lodash.cloneDeep(this.mapTableItemTemplate.company),
          platform: this.$lodash.cloneDeep(this.mapTableItemTemplate.platform),
          // pnbpFee: this.$lodash.cloneDeep(this.mapTableItemTemplate.pnbpFee),
          assign: this.$lodash.cloneDeep(this.mapTableItemTemplate.assign)
        })

        this.createEditScript.mapTable.items[0].office.value = this.filter.office
        this.createEditScript.mapTable.filteredItems[0].office.value = this.filter.office
      }

      this.counter++
    },

    // get all, no pagination
    async populateBussUnit() {
      // URL builder
      let getUrl = "/bussUnit/getAll"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.mapTableItemTemplate.bussUnitAvailOptions = []
            for(let i = 0; i < response.data.data.length; i++){
              this.mapTableItemTemplate.bussUnitAvailOptions.push({
                value: response.data.data[i].bussUnit,
                text: response.data.data[i].bussUnitDesc
              })
            }
          }
          else{
            this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    
    async populateCompany() {
      // URL builder
      let getUrl = "/company/getAll"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.mapTableItemTemplate.companyAvailOptions = []
            for(let i = 0; i < response.data.data.length; i++){
              this.mapTableItemTemplate.companyAvailOptions.push({
                value: response.data.data[i].id,
                text: response.data.data[i].name
              })
            }
          }
          else{
            this.$helper.toastError(this, "Load Daftar Company Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Company Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Company Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    async populatePlatform() {
      // URL builder
      let getUrl = "/platform/getAll"
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl).then(response => {
          if(response.status == 200){
            this.mapTableItemTemplate.platformAvailOptions = []
            for(let i = 0; i < response.data.data.length; i++){
              this.mapTableItemTemplate.platformAvailOptions.push({
                value: response.data.data[i].id,
                text: response.data.data[i].name
              })
            }
          }
          else{
            this.$helper.toastError(this, "Load Daftar Platform Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Platform Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Platform Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    async populateOffice(query = "") {
      this.mapTableItemTemplate.officeData.isLoaded = false
      this.mapTableItemTemplate.officeData.totalPages = 0
      this.mapTableItemTemplate.officeData.totalRows = 0
      this.mapTableItemTemplate.officeData.currentPage = 1
      this.mapTableItemTemplate.officeData.lastQuery = query
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.mapTableItemTemplate.officeData.currentPage - 1, this.mapTableItemTemplate.officeData.perPage)
      if(query !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = query
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.mapTableItemTemplate.officeData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.mapTableItemTemplate.officeData.options.push(response.data.data.data[i])
            }
            this.mapTableItemTemplate.officeData.totalRows = response.data.data.totalElements
            this.mapTableItemTemplate.officeData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.mapTableItemTemplate.officeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendSelectOffice() {
      this.mapTableItemTemplate.officeData.isLoaded = false
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.mapTableItemTemplate.officeData.currentPage, this.mapTableItemTemplate.officeData.perPage)
      if(this.mapTableItemTemplate.officeData.lastQuery !== ""){
        params['filterType'] = "nameFull"
        params['filterValue'] = this.mapTableItemTemplate.officeData.lastQuery
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.mapTableItemTemplate.officeData.options.push(response.data.data.data[i])
            }
            this.mapTableItemTemplate.officeData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.mapTableItemTemplate.officeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
  },
  async mounted() {
    await this.populateBussUnit()
    await this.populateCompany()
    await this.populatePlatform()
    await this.populateOffice()

    this.getScript(this.$route.params.scriptId)
  },
}
</script>

<style>
.filter-option .multiselect__tags{
  background: #ededed !important;
}
.filter-option .multiselect__tags .multiselect__single{
  background: #ededed !important;
}
</style>
